<div class="tiptap-editor">
  <div #editorContainer class="editor-content"></div>
  <div class="toolbar" *ngIf="showToolbar">
    <ion-button
      fill="clear"
      class="btn-small toolbar-button"
      (click)="toggleBold()"
      [class.active]="isBoldActive"
      title="Bold (Cmd+B)"
    >
      <strong>B</strong>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small toolbar-button"
      (click)="toggleItalic()"
      [class.active]="isItalicActive"
      title="Italic (Cmd+I)"
    >
      <em>I</em>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small toolbar-button"
      (click)="toggleCode()"
      [class.active]="isCodeActive"
      title="Code"
    >
      <ion-icon name="code-slash-outline"></ion-icon>
    </ion-button>
    <div class="toolbar-separator"></div>
    <ion-button
      fill="clear"
      class="btn-small toolbar-button"
      (click)="addLink()"
      title="Add Link (Cmd+K)"
    >
      <ion-icon name="link-outline"></ion-icon>
    </ion-button>
  </div>
</div>

<div class="menu" style="visibility: hidden">
  <ion-button
    fill="clear"
    class="btn-small"
    (click)="addLink()"
    style="color: white"
  >
    <ion-icon name="link-outline" style="margin-right: 3px"></ion-icon>
    Add link
  </ion-button>
  <ion-button
    fill="clear"
    class="btn-small"
    (click)="removeStyling()"
    style="color: white"
  >
    <ion-icon name="close-outline" style="margin-right: 3px"></ion-icon>
    Remove formatting
  </ion-button>
</div>
